import type { TokenStore } from "@/domains/tokens/token-store"

import {
  calculateDependentAmount0FromAmount1,
  calculateDependentAmount1FromAmount0,
} from "./deposit-dependent-amount"

export type DepositQuoteContext = {
  sqrtPriceX96Current: bigint | undefined
  tickLower: number | undefined
  tickUpper: number | undefined
  token0: TokenStore
  token1: TokenStore
  fee: number
}

const hasCompleteQuoteContext = (ctx: DepositQuoteContext): boolean =>
  ctx.sqrtPriceX96Current !== undefined &&
  ctx.tickLower !== undefined &&
  ctx.tickUpper !== undefined

export const quoteToken1FromToken0 = (
  amount0: bigint,
  ctx: DepositQuoteContext,
): bigint | undefined => {
  if (amount0 <= 0n) return 0n
  if (!hasCompleteQuoteContext(ctx)) return undefined
  try {
    return calculateDependentAmount1FromAmount0({
      amount0,
      sqrtPriceX96Current: ctx.sqrtPriceX96Current,
      tickLower: ctx.tickLower,
      tickUpper: ctx.tickUpper,
      token0: ctx.token0,
      token1: ctx.token1,
      fee: ctx.fee,
    })
  } catch {
    return undefined
  }
}

export const quoteToken0FromToken1 = (
  amount1: bigint,
  ctx: DepositQuoteContext,
): bigint | undefined => {
  if (amount1 <= 0n) return 0n
  if (!hasCompleteQuoteContext(ctx)) return undefined
  try {
    return calculateDependentAmount0FromAmount1({
      amount1,
      sqrtPriceX96Current: ctx.sqrtPriceX96Current,
      tickLower: ctx.tickLower,
      tickUpper: ctx.tickUpper,
      token0: ctx.token0,
      token1: ctx.token1,
      fee: ctx.fee,
    })
  } catch {
    return undefined
  }
}
